<template>
  <div class="ui-skeleton" />
</template>

<script setup lang="ts"></script>
